import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaKelompok: Yup.string().required("Masukan nama kelompok anggaran"),
    idJenis: Yup.string().required("Pilih jenis anggaran"),
  });
